import SlidersSvg from '@assets/images/svg/sliders.svg';
import React from 'react';

export interface SlidersIconProps {
    size?: number;
    color?: string;
}

export const SlidersIcon = React.memo<SlidersIconProps>(function SlidersIcon({ size = 24, color = '#1A1A1A' }) {
    return <SlidersSvg width={size} height={size} color={color} />;
});

export default SlidersIcon;
